import request from '@/utils/request'

// 进订单页获取数据
export function getList(data) {
  return request({
    // baseURL: process.env.VUE_APP_TM_API, //购物车接口单独的端口
    url:
      '/exhibition/orderInfo/list?current=' +
      data.current +
      '&size=' +
      data.size +
      '&orderNo=' +
      data.orderNo +
      '&netAddress=' +
      data.netAddress +
      '&netCode=' +
      data.netCode +
      '&orderStatus=' +
      data.orderStatus,
    method: 'get',
    data,
  })
}

// 进订状态
export function getState(data, type) {
  return request({
    // baseURL: process.env.VUE_APP_TM_API, //购物车接口单独的端口
    url: '/exhibition/orderInfo/read',
    method: type,
    data,
  })
}

// 现货列表
export function getSpot(data) {
  return request({
    // baseURL: process.env.VUE_APP_TM_API, //购物车接口单独的端口
    url:
      '/exhibition/orderInfo/detail/list?current=' +
      data.current +
      '&styleNumber=' +
      data.styleNumber +
      '&size=' +
      data.size +
      '&id=' +
      data.id,
    method: 'get',
    data,
  })
}

// 确认收货
export function confirmReceive(data) {
  return request({
    // baseURL: process.env.VUE_APP_TM_API, //购物车接口单独的端口
    url: `/exhibition/orderInfo/confirmOrder/${data.id}`,
    method: 'PUT',
    data,
  })
}
